import Api from '../services/Api'
// we now have an API object from the above

export default {
  getcountries(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.3'
      }
    }
    return Api().get('/country/', headerData)
  },
  getCategories(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.3'
      }
    }
    return Api().get('/category/', headerData)
  }
}
